module.exports = __webpack_public_path__ + "right.svg?a84c0578d33c96939262b04055573022";


//////////////////
// WEBPACK FOOTER
// ./assets/right.svg
// module id = 13
// module chunks = 0